module.exports = __webpack_public_path__ + "img/img5.d70f138b.svg";